<template>
  <div :class="{compressed}" class="items-grid">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import {useCompressed} from "~/composables/items-compressed";

const {compressed} = useCompressed()
</script>

<style lang="scss" scoped>


.items-grid {
  width: 100%;
  gap: 2.4rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  justify-content: center;

  @media screen and (max-width: 1115px) {
    justify-content: center;
  }
  @media screen and (max-width: 979px) {
    gap: 2rem;
  }
  @media screen and (max-width: 768px) {
    &.compressed {
      gap: 10px;
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    }
  }
  @media screen and (max-width: 625px) {
    gap: 1.2rem;
  }
}
</style>
